import { useParams } from 'react-router-dom';

import { AppCreateIapPollPage } from '~/components/pages/AppCreateIapPollPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppCreateIapPollRoute: React.FC = () => {
  const { appId } = useParams();
  const navigate = useNavigate();

  if (!appId) {
    navigate('/');

    return null;
  }

  return (
    <DashboardTemplate appId={appId} noAppPreviewOverlap>
      <AppCreateIapPollPage appId={appId} />
    </DashboardTemplate>
  );
};
